import BulkActionsRow from '@/components/BulkActionsRow';

export default BulkActionsRow;
